"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const redux_observable_1 = require("redux-observable");
const _folderTree = require("../../modules/files/tree/epics");
const connect_1 = require("./connect");
const linkedFolders_1 = require("./linkedFolders");
const linkFolders_1 = require("./linkFolders");
const projects_1 = require("./projects");
const detachFolders_1 = require("./detachFolders");
const resyncFolders_1 = require("./resyncFolders");
const folderTreeEpics = _folderTree.default('vektorio');
exports.allEpics = (0, redux_observable_1.combineEpics)(connect_1.allConnectEpics, linkedFolders_1.fetchLinkedFolders, linkFolders_1.linkFolders, projects_1.fetchProjects, folderTreeEpics.fetchTree, detachFolders_1.detachFolders, resyncFolders_1.resyncFolders);
//# sourceMappingURL=index.js.map